export const promotionMask = {
  mask: 'AAAAAAAAAAAAAAAAAAAA',
  tokens: {
    A: {
      pattern: /^[0-9a-zA-Z]{1,20}$/,
      transform: (v) => v.toLocaleUpperCase(),
    },
  },
}
